import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table, Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { dateFilter } from "react-bootstrap-table2-filter";
import DatePicker from "react-multi-date-picker";
import moment from "moment";
import { Rocket } from "@mui/icons-material";

function CompletedExam() {
  const { SearchBar, ClearSearchButton } = Search;
  const { ExportCSVButton } = CSVExport;
  const [isOpen, setIsOpen] = useState(false);
  const [mark, setmark] = useState("");
  const [Feedback, setFeedback] = useState("");
  const [data, setdata] = useState([]);
  const [ass, setass] = useState([]);
  const [isOpen1, setIsOpen1] = useState(true);
  const [isOpen2, setIsOpen2] = useState(false);
  const [data1, setdata1] = useState();
  const apiURL = process.env.REACT_APP_API_URL;
  const user = JSON.parse(sessionStorage.getItem("admin"));

  const showModal = (item) => {
    setIsOpen(true);
    setdata1(item);
  };
  const oncl1 = () => {
    setIsOpen1(true);
    setIsOpen2(false);
  };
  const oncl2 = () => {
    setIsOpen1(false);
    setIsOpen2(true);
  };
  const hideModal = () => {
    setIsOpen(false);
  };
  const [endDate, setendDate] = useState(new Date());
  const [startDate, setstartDate] = useState(new Date());

  useEffect(() => {
    getusers();

    getexam1();
  }, []);
  console.log(ass, "datadhd");
  const getusers = () => {
    try {
      axios
        .get(`/api/user/getalluploadexam`)
        .then(function (response) {
          if (response.status === 200) {
            console.log(response.data);
            //  localStorage.setItem("userdata",JSON.stringify(response.data.userdata));
            setdata(
              response.data.success.filter((data) => data.adminid === user._id)
            );
            // setdata1(response.data.exam);
            return;
          } else {
            //alert("Can't able to fetch ");
            //setdatacondition(true);
            return;
          }
        })
        .catch(function (error) {
          // setdatacondition(true);
          console.log(error.message.data);
          //alert("Can't able to fetch ");
          return;
        });
    } catch (error) {
      console.warn(error);
      alert("Can't able  to fetch ");
      // setdatacondition(true);
      return error;
    }
  };
  const getexam1 = () => {
    try {
      axios
        .get(`/api/user/getalluploadexamremark`)
        .then(function (response) {
          if (response.status === 200) {
            console.log(response.data);
            //  localStorage.setItem("userdata",JSON.stringify(response.data.userdata));
            setass(
              response.data.success.filter((data) => data.adminid === user._id)
            );
            // setdata1(response.data.exam);
            return;
          } else {
            //alert("Can't able to fetch ");
            //setdatacondition(true);
            return;
          }
        })
        .catch(function (error) {
          // setdatacondition(true);
          console.log(error.message.data);
          //alert("Can't able to fetch ");
          return;
        });
    } catch (error) {
      console.warn(error);
      alert("Can't able  to fetch ");
      // setdatacondition(true);
      return error;
    }
  };

  const sendmark = async () => {
    try {
      const config = {
        url: "/user/uploadexamremark",
        method: "post",
        baseURL: "/api",
        headers: { "content-type": "application/json" },
        data: {
          uploadexamid: data1._id,
          mark: mark,
          feedback: Feedback,
          adminid: user._id,
          examid: data1.examid,
          studentid: data1.studentid,
        },
        //responseType:"application/json"
      };
      let res = await axios(config);
      if (res.status === 200) {
        console.log(res.data);
        alert("Remark submitted successfully");
        // navigation.navigate('TabContent');
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const columns = [
    {
      dataField: "examid?.examtitle",
      text: "Title",
    },
    {
      dataField: "examid?.examdate",
      text: "Exam Date",
    },
    {
      dataField: "examid?.examsubject",
      text: "Subject",
    },
    {
      dataField: "examid?.standard",
      text: "Class ",
    },
    {
      dataField: "examid?.examtype",
      text: "Type",
      formatter: (cell, row) => {
        console.log(row);
        return (
          <div>
            <p>
              {row.examtype === "standard"
                ? "Whole Class"
                : "Individual Student"}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "studentid.name",
      text: "Student Name",
    },

    {
      dataField: "examid?.others",
      text: "Others ",
    },
    {
      dataField: "examid?.teacherid.name",
      text: "Teacher Name",
      formatter: (cell, row) => {
        console.log(row);
        return (
          <div>
            <p>{row.teacherid ? row.teacherid?.name : "Admin"}</p>
          </div>
        );
      },
    },

    {
      dataField: "examid?.mark",
      text: "Mark",
    },
    {
      dataField: "",
      text: "Completed Date",
      formatter: (cell, row) => {
        console.log(row);
        return (
          <div>
            <p>{moment(row.CreatedAt).format("DD/MM/YYYY")}</p>
          </div>
        );
      },
    },

    {
      dataField: "",
      text: "Given Exam file",
      formatter: (cell, row) => {
        console.log(row);
        return (
          <div>
            {row.examid?.examfile?.map((data) => (
              <a
                className="btn btn-success"
                style={{ marginBottom: 10 }}
                href={"/exam/" + data.file}
              >
                File
              </a>
            ))}
          </div>
        );
      },
    },
    {
      dataField: "",
      text: "Completed Exam file",
      formatter: (cell, row) => {
        console.log(row);
        return (
          <div>
            {row.examfile?.map((data) => (
              <a
                className="btn btn-success"
                style={{ marginBottom: 10 }}
                href={"/Exam/" + data.file}
              >
                File
              </a>
            ))}
          </div>
        );
      },
    },
    {
      dataField: "",
      text: "Action",
      formatter: (cell, row) => {
        console.log(row);
        return (
          <div>
            <button className="btn btn-success" onClick={() => showModal(row)}>
              Add Remarks
            </button>
          </div>
        );
      },
    },
  ];
  const columns1 = [
    {
      dataField: "examid?.examtitle",
      text: "Title",
    },
    {
      dataField: "examid?.examdate",
      text: "Exam Date",
    },
    {
      dataField: "examid?.examsubject",
      text: "Subject",
    },
    {
      dataField: "examid?.standard",
      text: "Class ",
    },
    {
      dataField: "examid?.examtype",
      text: "Type",
      formatter: (cell, row) => {
        console.log(row);
        return (
          <div>
            <p>
              {row.examtype === "standard"
                ? "Whole Class"
                : "Individual Student"}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "studentid.name",
      text: "Student Name",
    },

    {
      dataField: "examid?.others",
      text: "Others ",
    },
    {
      dataField: "examid?.teacherid.name",
      text: "Teacher Name",
      formatter: (cell, row) => {
        console.log(row);
        return (
          <div>
            <p>{row.teacherid ? row.teacherid?.name : "Admin"}</p>
          </div>
        );
      },
    },

    {
      dataField: "examid?.mark",
      text: "Mark",
    },
    {
      dataField: "",
      text: "Completed Date",
      formatter: (cell, row) => {
        console.log(row);
        return (
          <div>
            <p>{moment(row.CreatedAt).format("DD/MM/YYYY")}</p>
          </div>
        );
      },
    },
    {
      dataField: "mark",
      text: "Obtained Marks",
    },
    {
      dataField: "feedback",
      text: "Remarks",
    },
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total px-4">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: data.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };
  const options1 = {
    paginationSize: 4,
    pageStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: ass.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };
  // data.filter((data) => {
  //   console.log(new Date(data.date.split("-").reverse().join("-")));
  //   console.log(Date.parse(data.date));
  // });
  // const search = () => {
  //   const filteredData = data1.filter(
  //     (data) =>
  //       new Date(data.date.split("-").reverse().join("-")) >=
  //         new Date(startDate.split("-").reverse().join("-")) &&
  //       new Date(data.date.split("-").reverse().join("-")) <=
  //         new Date(endDate.split("-").reverse().join("-"))
  //   );
  //   setdata(filteredData);
  // };

  return (
    <div style={{ background: "#fff" }}>
      <h2 style={{ color: "#01a695", textAlign: "center" }}>Completed exam </h2>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          marginTop: "30px",
        }}
      >
        {" "}
        <div>
          <a className="btn btn-success" onClick={oncl1}>
            CompletedExam
          </a>
        </div>
        <div>
          <a className="btn btn-success" onClick={oncl2}>
            Remarks
          </a>
        </div>
      </div>
      <div className="row pb-3 px-3">
        <div className="col-md-2">
          {/* <h7>Date From</h7> */}
          {/* <DatePicker
            style={{ height: "35px", width: "140px", marginRight: "-5px" }}
            placeholder="DD-MM-YYYY"
            format="DD-MM-YYYY"
            type="input-icon"
            onChange={(date) => setstartDate(date.format("DD-MM-YYYY"))}
          />
        </div>
        <div className="col-md-2">
          <h7>Date To</h7>
          <DatePicker
            style={{ height: "35px", width: "140px", marginRight: "-5px" }}
            placeholder="DD-MM-YYYY"
            format="DD-MM-YYYY"
            type="input-icon"
            onChange={(date) => setendDate(date.format("DD-MM-YYYY"))}
          /> */}
        </div>
        {/* <div className="col-md-2">
          <button
            className="btn btn-primary"
            style={{ marginTop: "20px" }}
            onClick={search}
          >
            filter
          </button>
        </div> */}
      </div>
      {isOpen1 ? (
        <ToolkitProvider
          keyField="id"
          data={data}
          columns={columns}
          search
          exportCSV={{
            fileName: "transaction.csv",
            blobType: "text/csv;charset=ansi",
          }}
        >
          {(props) => (
            <div>
              <span className="px-3 mr-auto ">
                <ExportCSVButton
                  className="btn-outline-success"
                  {...props.csvProps}
                >
                  Export to Excel
                </ExportCSVButton>
              </span>
              <span className="pl-4 mr-5 mt-5">
                <SearchBar className="form-control " {...props.searchProps} />
              </span>
              <ClearSearchButton
                className="btn-outline-info"
                {...props.searchProps}
              />

              <hr />
              <div className="table-responsive" style={{ margin: "30px" }}>
                <BootstrapTable
                  keyField="id"
                  striped
                  hover
                  condensed
                  columns={columns}
                  data={data}
                  pagination={paginationFactory(options)}
                  {...props.baseProps}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      ) : (
        ""
      )}
      {isOpen2 ? (
        <ToolkitProvider
          keyField="id"
          data={ass}
          columns={columns1}
          search
          exportCSV={{
            fileName: "transaction.csv",
            blobType: "text/csv;charset=ansi",
          }}
        >
          {(props) => (
            <div>
              <span className="px-3 mr-auto ">
                <ExportCSVButton
                  className="btn-outline-success"
                  {...props.csvProps}
                >
                  Export to Excel
                </ExportCSVButton>
              </span>
              <span className="pl-4 mr-5 mt-5">
                <SearchBar className="form-control " {...props.searchProps} />
              </span>
              <ClearSearchButton
                className="btn-outline-info"
                {...props.searchProps}
              />

              <hr />
              <div className="table-responsive" style={{ margin: "30px" }}>
                <BootstrapTable
                  keyField="id"
                  striped
                  hover
                  condensed
                  columns={columns}
                  data={data}
                  pagination={paginationFactory(options1)}
                  {...props.baseProps}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      ) : (
        ""
      )}
      {/* <Table striped bordered hover size="sm">
  <thead>
    <tr>
      <th>S.no</th>
      <th>exam Name</th>
      <th>Amount</th>
      <th>User name</th>
      <th>User Email</th>
      
      <th >Booked Date</th>
      <th >exam Date</th>
      <th>Payment Method</th>
      
    </tr>
  </thead>
  <tbody>
    {data??.map((e)=>(
       <tr>
       <td>1</td>
       <td>{e.exam[0].examtitle}</td>
       <td>{e.exam[0].examamount}</td>
       <td>{e.user[0].name}</td>
    <td>{e.user[0].email}</td>
    <td>{e.examdate}</td>
    <td>{e.bookedtime}</td>
    <td>{e.paymentmethod}</td>
       
     </tr>
    ))}
   
    

  <a href="https://wa.me/country_code_and_your_phone_number" className="whatsapp_float" target="_blank"> <i className="fa fa-whatsapp whatsapp-icon"></i></a>

    
   
  </tbody>
</Table> */}
      <Modal show={isOpen} onHide={hideModal}>
        <Modal.Header>
          <Modal.Title>Remark</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <form>
              {/* <FormGroup>
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-mutiple-checkbox-label">
                    Select Country
                  </InputLabel>
                  <Select
                    labelId="demo-mutiple-checkbox-label"
                    id="demo-mutiple-checkbox"
                    multiple
                    value={countryName}
                    onChange={handleChange}
                    input={<Input />}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={MenuProps}
                  >
                    {data??.map((name) => (
                      <MenuItem key={name._id} value={name?.countryName}>
                        <Checkbox
                          checked={countryName.indexOf(name?.countryName) > -1}
                        />
                        <ListItemText primary={name?.countryName} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </FormGroup> */}
              {/* <br></br> */}
              <div className="form-group">
                <label>Marks</label>
                <input
                  type="number"
                  placeholder="Enter Mark"
                  className="form-control"
                  onChange={(e) => setmark(e.target.value)}
                ></input>
                <label className="mt-2">Feedback</label>
                <input
                  type="text"
                  placeholder="Enter Feedback"
                  className="form-control"
                  onChange={(e) => setFeedback(e.target.value)}
                ></input>
              </div>{" "}
              <br></br>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="info" onClick={hideModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={sendmark}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default CompletedExam;
